<template>
  <div>
    <vue-headful title="Bevestigde opdracht(en)" />
    <Header page_title="Bevestigde opdracht(en)" />
    <div>
      <div class="px-4 mx-2">
        <div class="container-fluid px-0 pb-1 mb-2">
          <p class="mt-3">
            <job-filter @filter-change="filterChanged" :showAll="false" :subbranch="true" />
          </p>
          <p class="mb-3">
            <strong v-if="results.meta.total == 1">{{ results.meta.total }} bevestigde opdracht</strong>
            <strong v-else>{{ results.meta.total }} bevestigde opdrachten</strong>
          </p>
          <div class="mb-5" v-if="results ? results.data && results.data.length > 0 : false">
              <template v-if="branch === '3'">
                  <JobCardHealthcare
                      v-for="job in results.data"
                      :key="job.job_id"
                      :job="job"
                      approved="true"
                      :arrow="true"
                  />
              </template>
              <template v-else>
                  <JobCard
                      v-for="(job, index) in results.data"
                      :key="job.job_id"
                      :job="job"
                      approved="true"
                      :arrow="true"
                  />
              </template>
            <Pagination :results="results" :api="api" @page-change="pageChanged" />
          </div>
          <Empty v-else text="Hier vind je je actieve opdrachten." />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import JobCard from "@/components/JobCard.vue";
import JobFilter from "@/components/JobFilter.vue";
import JobCardHealthcare from "@/components/JobCardHealthcare.vue";

export default {
  data: function() {
    return {
      api: "jobs/approved",
      results: null,
      filterValues: {
        showAll: false,
        maxShown: 20,
        subbranch: ''
      },
        branch: localStorage.getItem('branch'),
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.results = await this.getListwithPages("jobs/approved");
      this.$store.state.loading = false;
    },
    async pageChanged(data) {
      this.results = await this.getListwithPages(data);
    },
    async filterChanged(data) {
      this.filterValues = data;
      this.$store.state.loading = true;

      if(this.filterValues.subbranch === '1')
        this.api = 'jobs/approved?subbranch=1';
      else if(this.filterValues.subbranch === '2')
        this.api = 'jobs/approved?subbranch=2';
      else
        this.api = 'jobs/approved';

      this.results = await this.getListwithPages(this.api);
      this.$store.state.loading = false;
    }
  },
  components: {
      JobCardHealthcare,
    JobFilter,
    JobCard
  }
};
</script>

<style scoped></style>
